/**
 * Product Form Submission (Standard - without file upload)
 * For main-product.liquid
 */
(function() {
  'use strict';

  function initProductFormSubmit() {
    const productForm = document.querySelector('.form');
    if (!productForm) return;

    const productData = window.productData;
    if (!productData) return;

    // Form submission
    productForm.addEventListener('submit', async function(e) {
      e.preventDefault();
      const formData = new FormData(productForm);
      const submitBtn = productForm.querySelector('[type="submit"]');
      const originalText = submitBtn.innerHTML;
      submitBtn.disabled = true;
      submitBtn.textContent = window.addingText || "Adding...";

      try {
        // Get checked upsell products
        const checkedUpsells = document.querySelectorAll('.product-upsell-form input[type="checkbox"]:checked');
        const upsellItems = Array.from(checkedUpsells).map(checkbox => ({
          id: parseInt(checkbox.value),
          quantity: 1
        }));

        // Create items array with main product and upsell products
        const items = [
          { id: parseInt(formData.get('id')), quantity: 1 },
          ...upsellItems
        ];

        const cartUrl = window.routes.cart_add_url + '.js';
        const response = await fetch(cartUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        });

        const data = await response.json();
        if (response.ok) {
          if (window.publish && window.PUB_SUB_EVENTS) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              action: 'add',
              variant: data,
              formData: Object.fromEntries(formData),
              product: productData
            });
          }
        } else {
          throw new Error(data.description || 'Failed to add to cart');
        }
      } catch (error) {
        console.error('Error:', error);
        if (window.publish && window.PUB_SUB_EVENTS) {
          publish(PUB_SUB_EVENTS.cartError, {
            error: error.message,
            context: 'add-to-cart',
            productId: productData.id
          });
        }
      } finally {
        submitBtn.disabled = false;
        submitBtn.innerHTML = originalText;
      }
    });
  }

  // Auto-initialize
  document.addEventListener('DOMContentLoaded', function() {
    initProductFormSubmit();
  });

  // Export for manual initialization
  window.initProductFormSubmit = initProductFormSubmit;
})();



